import { useEffect, useState } from "react"

import { useSearchParams } from "react-router-dom"

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
]

const useSaveUTMs = () => {
  const [searchParams] = useSearchParams()
  const [utms, setUtms] = useState<Record<string, string>>({})

  useEffect(() => {
    const utmData = localStorage.getItem("utm_params")
    if (utmData) {
      const { utms: savedUtms, savedAt } = JSON.parse(utmData)
      const now = Date.now()
      const sevenDays = 7 * 24 * 60 * 60 * 1000

      if (now - savedAt > sevenDays) {
        localStorage.removeItem("utm_params")
        setUtms({})
      } else {
        setUtms(savedUtms || {})
      }
    }
  }, [])

  useEffect(() => {
    const utms: Record<string, string> = {}
    UTM_KEYS.forEach((key) => {
      const value = searchParams.get(key)
      if (value) utms[key] = value
    })

    if (Object.keys(utms).length > 0) {
      const utmData = {
        utms,
        savedAt: Date.now(),
      }
      localStorage.setItem("utm_params", JSON.stringify(utmData))
      setUtms(utms)
    }
  }, [searchParams])

  return utms
}

export default useSaveUTMs
